<div class="l-contents">
  <div class="form-content">
    <div
      id="search-condition"
      class="accordion-panel"
    >
      <section class="panel panel-default">
        <div class="panel-heading">
          <span class="panel-title">抽出条件</span>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="form-content__item bl-select-unique">
              <span>帳票機能名</span>
              <span>:</span>
              <div class="form-content__input-select">
                <bl-select
                  #reportName
                  id="report-name"
                  [(value)]="searchInfo && searchInfo.pageId"
                  [items]="reportNameDivArray"
                  [option]="{ valueProperty: 'value', labelProperty: 'text' }"
                >
                </bl-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-content__item bl-select-unique">
              <span>抽出日付範囲</span>
              <span>:</span>
              <div class="form-content__input-middle addinfo__body-input">
                <bl-date
                  blCustomFocus
                  #searchDateStart
                  [id]="'searchDateStart'"
                  [(value)]="searchInfo.searchDateStart"
                  [era]="Era.Ad"
                >
                </bl-date>
              </div>
              <span class="form-content__range">～</span>
              <div class="form-content__input-middle addinfo__body-input">
                <bl-date
                  blCustomFocus
                  #searchDateEnd
                  [id]="'searchDateEnd'"
                  [(value)]="searchInfo.searchDateEnd"
                  [era]="Era.Ad"
                >
                </bl-date>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-content__item bl-select-unique">
              <span>出力状況</span>
              <span>:</span>
              <div class="form-content__input-select">
                <bl-select
                  #outputStatus
                  id="output-status"
                  [(value)]="searchInfo.outputStatusDiv"
                  [items]="statusDivEnumArray"
                  [option]="{ valueProperty: 'value', labelProperty: 'text' }"
                >
                </bl-select>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="result">
      <bl-reference-grid
        id="detail-ref-grid"
        #refGrid
        [gridHeight]="'auto'"
        [gridOptions]="gridOptions"
        [rowHeight]="28"
        [pagination]="false"
        (onReady)="onReadyGrid()"
        (selectedRowEvent)="onSelectedRowEvent($event.data)"
      >
      <div grid-footer >
        <div class="right-area">
          <share-auto-update
            [allowAutoUpdate]="true"
            [latestUpdateDateTime]="latestUpdateDateTime"
            [intervalUnit]="AutoUpdateIntervalUnit.Second"
            [second]="interval"
            [storageKey]="accessKey"
            (autoUpdateEvent)="reload()"
          ></share-auto-update>
          <div class="paging">
            <bl-paging #paging
              [totalCount]="totalCount"
              [defaultSize]="pageSize"
              [pageSizePatterns]="pageSizePatterns"
              (changePageSize)="onChangePageSize($event)"
              (goPageEvent)="onGoPageEvent($event)"
            >
            </bl-paging>
          </div>
        </div>
      </div>
      </bl-reference-grid>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/page/report-output-status-page/report-output-status-page.component.html